module.exports = __webpack_public_path__ + "img/7_5ccb37d6c.png";